import React from 'react';

const LoadingScreen = () => {
  return (
    <div>
      <h1>Loading Screen</h1>
    </div>
  );
};

export default LoadingScreen;